import React from 'react';
import {Button, Tooltip} from '@material-ui/core';
import UploadModal from './UploadModal';

type Props = {apiToken: string; fileKey: string}

function isAdProcessing(apiToken: string, adKey: string): Promise<boolean> {
  return fetch(
    `/api/v1/requestfiles/status/${encodeURIComponent(adKey)}`,
    {headers: {Authorization: apiToken}}
  ).then(response =>
    response.json().then(json =>
      json.data.processing === true));
}

const AdUploadButton: React.FC<Props> = ({apiToken, fileKey}: Props) => {
  const [isEnabled, setIsEnabled] = React.useState(false);
  const [disabledReason, setDisabledReason] = React.useState('Checking ad status...');
  const [uploadFileKey, setUploadFileKey] = React.useState('');

  React.useEffect(() => {
    isAdProcessing(apiToken, fileKey)
      .then(isProcessing => {
        setIsEnabled(!isProcessing);
        setDisabledReason(isProcessing ? 'Ad is being processed, and can no longer be changed.' : '');
      });
  });

  // Additional span element is needed for MUI tooltip
  // to work on a disabled element.
  // https://material-ui.com/components/tooltips/#disabled-elements
  return (
    <>
      {uploadFileKey
        ? <UploadModal
            adFileKey={uploadFileKey}
            isOpen={true}
            onClose={() => setUploadFileKey('')}
          />
        : undefined}

      {isEnabled
        ? <Button
            type="button"
            onClick={() => setUploadFileKey(fileKey)}
          >Upload</Button>
        : <Tooltip title={disabledReason}>
            <span>
              <Button
                type="button"
                disabled={true}
              >Upload</Button>
            </span>
          </Tooltip>}
    </>
  ); 
}
export default AdUploadButton;
